const EmptyCurrencyIcon = () => {
	return (
		<svg width='245' height='124' viewBox='0 0 245 124' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g filter='url(#filter0_d_5228_69278)'>
				<path
					d='M34.5 51C34.5 46.5817 38.0817 43 42.5 43H202.5C206.918 43 210.5 46.5817 210.5 51V90C210.5 94.4183 206.918 98 202.5 98H42.5C38.0817 98 34.5 94.4183 34.5 90V51Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter1_d_5228_69278)'>
				<path
					d='M202.5 97.5996V98H42.5V97.5996H202.5ZM210.1 90V51C210.1 46.8026 206.697 43.4004 202.5 43.4004H42.5C38.3026 43.4004 34.9004 46.8026 34.9004 51V90C34.9004 94.1974 38.3026 97.5996 42.5 97.5996V98C38.0817 98 34.5 94.4183 34.5 90V51C34.5 46.5817 38.0817 43 42.5 43H202.5L202.912 43.0107C207.139 43.2252 210.5 46.7199 210.5 51V90C210.5 94.2801 207.139 97.7748 202.912 97.9893L202.5 98V97.5996C206.697 97.5996 210.1 94.1974 210.1 90Z'
					fill='#D0D2DC'
					fillOpacity='0.5'
					shapeRendering='crispEdges'
				/>
			</g>
			<g filter='url(#filter2_d_5228_69278)'>
				<path
					d='M22.5 45C22.5 39.4772 26.9772 35 32.5 35H212.5C218.023 35 222.5 39.4772 222.5 45V80C222.5 85.5228 218.023 90 212.5 90H32.5C26.9772 90 22.5 85.5228 22.5 80V45Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter3_d_5228_69278)'>
				<path
					d='M212.5 89.5996V90H32.5V89.5996H212.5ZM222.1 80V45C222.1 39.6981 217.802 35.4004 212.5 35.4004H32.5C27.1981 35.4004 22.9004 39.6981 22.9004 45V80C22.9004 85.3019 27.1981 89.5996 32.5 89.5996V90C27.1498 90 22.7805 85.7983 22.5127 80.5146L22.5 80V45C22.5 39.4772 26.9772 35 32.5 35H212.5L213.015 35.0127C218.298 35.2805 222.5 39.6498 222.5 45V80L222.487 80.5146C222.228 85.6279 218.128 89.7281 213.015 89.9873L212.5 90V89.5996C217.802 89.5996 222.1 85.3019 222.1 80Z'
					fill='#D0D2DC'
					fillOpacity='0.5'
					shapeRendering='crispEdges'
				/>
			</g>
			<g filter='url(#filter4_d_5228_69278)'>
				<path
					d='M10.5 38C10.5 31.3726 15.8726 26 22.5 26H222.5C229.127 26 234.5 31.3726 234.5 38V70C234.5 76.6274 229.127 82 222.5 82H22.5C15.8726 82 10.5 76.6274 10.5 70V38Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter5_d_5228_69278)'>
				<path
					d='M222.5 81.5996V82H22.5V81.5996H222.5ZM234.1 70V38C234.1 31.5935 228.907 26.4004 222.5 26.4004H22.5C16.0935 26.4004 10.9004 31.5935 10.9004 38V70C10.9004 76.4065 16.0935 81.5996 22.5 81.5996V82L22.1904 81.9961C15.809 81.8345 10.6655 76.691 10.5039 70.3096L10.5 70V38C10.5 31.3726 15.8726 26 22.5 26H222.5C229.127 26 234.5 31.3726 234.5 38V70L234.496 70.3096C234.335 76.691 229.191 81.8345 222.81 81.9961L222.5 82V81.5996C228.907 81.5996 234.1 76.4065 234.1 70Z'
					fill='#D0D2DC'
					fillOpacity='0.5'
					shapeRendering='crispEdges'
				/>
			</g>
			<path
				d='M22.5 46C22.5 41.5817 26.0817 38 30.5 38H46.5C50.9183 38 54.5 41.5817 54.5 46V62C54.5 66.4183 50.9183 70 46.5 70H30.5C26.0817 70 22.5 66.4183 22.5 62V46Z'
				fill='#96A4B5'
				fillOpacity='0.16'
			/>
			<path
				d='M66.5 64C66.5 61.7909 68.2909 60 70.5 60H94.5C96.7091 60 98.5 61.7909 98.5 64C98.5 66.2091 96.7091 68 94.5 68H70.5C68.2909 68 66.5 66.2091 66.5 64Z'
				fill='#96A4B5'
				fillOpacity='0.16'
			/>
			<path
				d='M194.5 64C194.5 61.7909 196.291 60 198.5 60H218.5C220.709 60 222.5 61.7909 222.5 64C222.5 66.2091 220.709 68 218.5 68H198.5C196.291 68 194.5 66.2091 194.5 64Z'
				fill='#96A4B5'
				fillOpacity='0.16'
			/>
			<path
				d='M66.5 44C66.5 41.7909 68.2909 40 70.5 40H125.5C127.709 40 129.5 41.7909 129.5 44V48C129.5 50.2091 127.709 52 125.5 52H70.5C68.2909 52 66.5 50.2091 66.5 48V44Z'
				fill='#96A4B5'
				fillOpacity='0.2'
			/>
			<path
				d='M159.5 44C159.5 41.7909 161.291 40 163.5 40H218.5C220.709 40 222.5 41.7909 222.5 44V48C222.5 50.2091 220.709 52 218.5 52H163.5C161.291 52 159.5 50.2091 159.5 48V44Z'
				fill='#96A4B5'
				fillOpacity='0.2'
			/>
			<defs>
				<filter
					id='filter0_d_5228_69278'
					x='24.5'
					y='38'
					width='196'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5228_69278' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5228_69278' result='shape' />
				</filter>
				<filter
					id='filter1_d_5228_69278'
					x='24.5'
					y='38'
					width='196'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5228_69278' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5228_69278' result='shape' />
				</filter>
				<filter
					id='filter2_d_5228_69278'
					x='12.5'
					y='30'
					width='220'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5228_69278' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5228_69278' result='shape' />
				</filter>
				<filter
					id='filter3_d_5228_69278'
					x='12.5'
					y='30'
					width='220'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5228_69278' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5228_69278' result='shape' />
				</filter>
				<filter
					id='filter4_d_5228_69278'
					x='0.5'
					y='21'
					width='244'
					height='76'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5228_69278' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5228_69278' result='shape' />
				</filter>
				<filter
					id='filter5_d_5228_69278'
					x='0.5'
					y='21'
					width='244'
					height='76'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5228_69278' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5228_69278' result='shape' />
				</filter>
			</defs>
		</svg>
	);
};

export default EmptyCurrencyIcon;
